// import guardTime from './guardTime'
import timeConfig from './timeConfig'

const zhCN = { 
  // guardTime: guardTime.zhCN 
  timeConfig: timeConfig.zhCN 
}
const enUS = {
  // guardTime: guardTime.enUS 
  timeConfig: timeConfig.enUS 
}
export default { zhCN, enUS }